import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const AuthApi = createApi({
  reducerPath: 'auth',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    setLogin: builder.mutation({
      query: body => ({
        url: 'api/auth/adminLogin',
        method: 'POST',
        body: body,
      }),
    }),
  }),
});

export const { useSetLoginMutation } = AuthApi;
